import { Frown, Meh, Smile } from "lucide-react";

export const FACES = [[1, Frown, "#C7353B"], [2, Meh, "#E67E22"], [3, Smile, "#1F9D55"]];

export function ratingStats(sales) {
  const rated = sales.filter((s) => s.rating >= 1 && s.rating <= 3);
  const by = { 1: 0, 2: 0, 3: 0 };
  rated.forEach((s) => { by[s.rating] += 1; });
  const n = rated.length;
  return { n, by, pct: n ? Math.round(((by[3] + by[2] * 0.5) / n) * 100) : null };
}

export function RatingBar({ sales, t, compact = false }) {
  const st = ratingStats(sales);
  if (!st.n) return <div className="text-xs text-muted-foreground" data-testid="rating-empty">{t("rating_none")}</div>;
  return (
    <div className={`flex items-center gap-3 ${compact ? "text-xs" : "text-sm"}`} data-testid="rating-bar" data-n={st.n} data-pct={st.pct}>
      <span className="font-black text-lg" style={{ color: st.pct >= 70 ? "#1F9D55" : st.pct >= 40 ? "#E67E22" : "#C7353B" }} data-testid="rating-pct">{st.pct}%</span>
      {FACES.map(([v, Icon, c]) => <span key={v} className="flex items-center gap-1" data-testid={`rating-count-${v}`}><Icon className="w-4 h-4" style={{ color: c }} />{st.by[v]}</span>)}
      <span className="text-muted-foreground">{st.n} {t("rating_votes")}</span>
    </div>
  );
}
